import { GenericStore } from '../../../util/mobx/generic-store/generic.store'
import { createStore } from '../../../util/mobx/generic-store/store-creator'

export class OverlayStore extends GenericStore {
  tourTipsShown = false
  orgChartToolTipsShown = false

  constructor() {
    super('OverlayStore')
    super.observe(this)
    super.persist({ encrypt: false })
  }

  // Mark tour as seen
  markTourAsSeen() {
    this.tourTipsShown = true
  }

  // Mark org chart tooltips as seen (after user invite sent)
  markOrgChartToolTipsAsSeen() {
    this.orgChartToolTipsShown = true
  }
}

export const {
  useStore: useOverlayStore,
  StoreProvider: OverlayStoreProvider,
} = createStore(new OverlayStore())
